import axios from "axios";

export const state = {
    sales: [],
};

export const getters = {
    sales: state => state.sales,
};

export const mutations = {
    setSales(state, newValue) {
        state.sales = newValue
    },
};

export const actions = {
    fetchSales({ commit }) {
        axios.get('/sales').then(res => {
            commit('setSales', res.data.sales);
        })
    },
};
